import { SubscriptionBase } from '@Base/Engagement/SubscriptionBase';

import "./Subscription.scss";

export class Subscription extends SubscriptionBase
{
	constructor()
	{
		super();
	}

	public override get GenericText(): string
	{
		return '<span class="subscribe__val">Sign Up</span><br /><span class="subscribe__exc">For Our Costume Club &amp; Receive <br /> Exclusive Deals &amp; Costume Ideas!</span>';
	}

	public override get GenericThanks(): string
	{
		return '<span class="subscribe__sent">Exclusive Deals &amp; Costume Ideas Are on Their Way to</span>';
	}
}